export * from './getPageInitialData';
export * from './getPhrases';
export * from './getDictionary';
export * from './getRegistrationTemplateData';
export * from './test-utils/createMockRouter';
export * from './checkUrl';
export * from './replaceVarsOnTranslation';
export * from './fetch';
export * from './runFileDownload';
export * from './JSXFromString';
export * from './getConfig';
export * from './getFetchErrorMessage';
export * from './getHomeQueryParams';
export * from './determinePathType';
export * from './getCurrentLocaleData';
export * from './locale';
